export default "__VITE_ASSET__DL7xNRy6__";